// Resolver for multilingual SEO landing pages.
// English holds the canonical structure + non-translatable fields (ctaInterest, related);
// FR/TR override only translatable text and inherit the rest from EN.
import { SEO_PAGES_EN } from "./seoPages.en";
import { SEO_PAGES_FR } from "./seoPages.fr";
import { SEO_PAGES_TR } from "./seoPages.tr";

const BY_LANG = { en: SEO_PAGES_EN, fr: SEO_PAGES_FR, tr: SEO_PAGES_TR };

export const SEO_PAGE_SLUGS = Object.keys(SEO_PAGES_EN);

// Suffix appended when a locale variant inherits the English title (no localized
// override yet). Keeps each locale variant of a landing page uniquely titled so
// SEO audit tools don't flag them as duplicates while proper translations are pending.
const LOCALE_TITLE_SUFFIX = {
  en: "",
  fr: " · Français",
  tr: " · Türkçe",
};

// Returns a single page merged with its EN base, or undefined if the slug is unknown.
export const getSeoPage = (slug, lang = "en") => {
  const base = SEO_PAGES_EN[slug];
  if (!base) return undefined;
  const override = (BY_LANG[lang] || {})[slug];
  const merged = override ? { ...base, ...override } : { ...base };
  // For non-EN locales that lack a proper translation, append a locale suffix
  // to any inherited title/description so search engines see distinct meta per
  // URL. Removed automatically once real translations are added to the locale file.
  const suffix = LOCALE_TITLE_SUFFIX[lang];
  if (suffix && lang !== "en") {
    if (!override || !override.title) merged.title = `${base.title}${suffix}`;
    if (!override || !override.description) merged.description = `${base.description}${suffix}`;
  }
  return merged;
};
